import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { listActiveFractionalNFTs, listFractionalNFTsByOwner } from "../../../hooks/FNFThook";

export default function ActiveCampaign(props) {
    const [activeCampaign, setActiveCampaign] = useState([]);
    const walletAddress = localStorage.getItem("WalletAddress");
   
    const tab = props.category;
   
    const settings = {
        dots: true,
        infinite: true,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1414,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1214,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1007,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 516,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    useEffect(() => {
        if (tab === "All Campaigns")
            getLiveFNFT();
        else
            getUserFNFT();
    }, [tab]);

    const getLiveFNFT = async () => {
        const params = {
            isFundingActive: true,
            sortBy : "createdAt",
        }
        const fnft = await listActiveFractionalNFTs(params);
        console.log("FNFT", fnft, fnft.data);
        
        if (fnft.success) {
            const Campaingn = fnft.data.filter((data) => data.fractionNftId)
            setActiveCampaign(fnft.data)
        }
    }
    const getUserFNFT = async () => {
        const params = {
            nftOwner: walletAddress,
            isFundingActive: true,
            sortBy : "createdAt",
        }
        const fnft = await listActiveFractionalNFTs(params);
        console.log("user fnft", fnft);

        if (fnft.success) {
            const Campaingn = fnft.data.filter((data) => data.fractionNftId)
            setActiveCampaign(fnft.data)
        }
    }
    console.log("campaigns", activeCampaign, tab);

    return (
        <div className="section_body swiper_artists overflow-hidden" style={{ marginBottom: "8vh" }}>
            {/* <h1>Campaign Length:{activeCampaign.length}</h1> */}
            <Slider {...settings}>
                {activeCampaign.map((campaign, index) => (
                    <div className="IDO" key={campaign._id}>
                        <div className="d-flex" style={{ flexDirection: "column", alignItems: "center" }}>
                            <div className="w-100 h-100" style={{ position: "relative" }}>
                                <Link to={`/campaign/${campaign._id}`}>
                                    <img
                                       src={campaign.campaignMedia[0]}
                                        alt={campaign.campaignName}
                                        className="IDOImg d-flex align-item-center justify-content-center border-bottom"
                                        style={{ alignItems: "center", objectFit: "cover" }}
                                    />
                                </Link>
                                <div className="border rounded-sm launchpad1__scroller1_icon m-2">
                                    <span className="badeIcon" style={{ color: "black", fontWeight: "bold" }}>
                                        {campaign.fractionalTokenSymbol}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="mx-4 IDO_block2">
                            <div className="IDOnae button-29" style={{ width: '50%', marginTop: "-3.6rem", position: "absolute", top: '-0.5rem', right: "-1.5rem" }}>
                                <h4 className='text-center my-1' style={{ alignItems: 'center', color: 'white' }}>
                                    {campaign.campaignName ? campaign.campaignName : "unknown"}
                                </h4>
                            </div>
                            <div className="mx-1 bggg d-flex align-items-center justify-content-between">
                                <div><span className="p4">Funding Status</span></div>
                                <div><span className="p4">{campaign.isFundingActive ? "Active" : "Inactive"}{campaign.fractionNftId}</span></div>
                            </div>
                            <div className="m-1 d-flex align-items-center justify-content-between">
                                <div><span className="p4">Project Start</span></div>
                                <div><span className="p4">{campaign.createdAt.split("T")[0]}</span></div>
                            </div>
                            <div className="m-1 d-flex align-items-center justify-content-between">
                                <div><span className="p4">Project End</span></div>
                                <div><span className="p4">{campaign.fractionalEndTime && campaign.fractionalEndTime.split("T")[0]}</span></div>
                            </div>
                            <div className="m-1 d-flex align-items-center justify-content-between">
                                <div><span className="p4">Token Supply</span></div>
                                <div><span className="p4">{campaign.totalTokenSupplied}/{campaign.fractionalTokenSupply}
                                </span></div>
                            </div>
                            <div className="m-1 d-flex align-items-center justify-content-between">
                                <div><span className="p4">Raised</span></div>
                                <div><span className="p4">
                                    {parseFloat(campaign.totalFundsRaised)} / {parseFloat(campaign.totalFundsDesired)} ETH
                                </span></div>
                            </div>
                            <div className="m-1 d-flex align-items-center justify-content-between">
                                <div><span className="p4">Resell NFTs</span></div>
                                <div><span className="p4">{campaign.resellValueOfNft}</span></div>
                            </div>
                            <div className="mt-2">
                                <Link to={`/idodetails/${campaign.fractionNftId}`}>
                                    <button className="p4 border-0 btn btn-bg" style={{ backgroundColor: '#0039a6', color: 'white', marginBottom: '1vw' }}>
                                        View Details
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
}
